import { Injectable } from '@angular/core';
import { Platform} from "ionic-angular";
import firebase from 'firebase';

@Injectable()
export class SpiltPanelProvider {

  public splitPanState:boolean;
  constructor(public platform:Platform) {
    this.splitPanState=false;
  }

  getSpiltPane(){
    let user = firebase.auth().currentUser;
    if(user){
      this.splitPanState=true;
      if(this.platform.width()>768){
        this.splitPanState=true;
      }
      else {
        this.splitPanState=false;
      }
    }
    else{
      this.splitPanState=false;
    }
    return this.splitPanState;
  }

}



// WEBPACK FOOTER //
// ./src/providers/spilt-panel/spilt-panel.ts